// CopyOf 'UiElements.js'
import { lazy } from "react";
const SuiteHome = lazy(() =>
  import("../../../Pages/Home/components/SuiteHome")
);

const Dashboradv3 = lazy(() => import("../../../Pages/Dashborad/index"));

const SelectBrand = lazy(() =>
  import("../../../Pages/Home/components/SelectBrand")
);
const Product = lazy(() => import("../../../Pages/Product"));
const Influencer = lazy(() => import("../../../Pages/Influencer"));
const InfluencerDetailContainer = lazy(() =>
  import("../../../Pages/Influencer/influencer_detail_container")
);

const ProductDetailContainer = lazy(() =>
  import("../../../Pages/Product/ProductDetailContainer")
);
const Reports = lazy(() => import("../../../Pages/Reports"));
// const EcommerceShop = lazy(() => import('../../../views/apps/ecommerce/shop'))

const Video = lazy(() => import("../../../Pages/Video/index"));

const Search = lazy(() => import("../../../Pages/Search/Search"));
const Published = lazy(() => import("../../../Pages/Published"));
const Widget = lazy(() => import("../../../Pages/Widget/Index"));
const AccountSettings = lazy(() =>
  import("../../../Pages/AccountSettings/AccountSetting")
);
const Support = lazy(() => import("../../../Pages/Support/Support"));
const VideoDetail = lazy(() =>
  import("../../../Pages/Video/Components/VideoDetail")
);
const VideoDetailContainer = lazy(() =>
  import("../../../Pages/Video/VideoDetailContainer")
);
const ChatIndex = lazy(() => import("../../../Pages/Chat/ChatIndex"));
const Campaign = lazy(() => import("../../../Pages/Campaign/CampaignIndex"));
import ChatDetail from "../../../Pages/Chat/ChatDetail";
import AskVyrillChat from "../../../Pages/AskVyrill";
import CreateCampaign from "../../../Pages/CreateCampaign";
import CampaignListPage from "../../../Pages/Video/CampaignListPage";
import VideoIndexContainer from "../../../Pages/Video/VideoIndexContainer";
import CampaignDetailPage from "../../../Pages/Video/CampaignDetailPage";

const Onboarding = lazy(() =>
  import("../../../Entry/EntryComponents/Onboarding")
);
const FirstTimeUser = lazy(() =>
  import("../../../Entry/EntryComponents/FirstTimeUser")
);
const ConfirmEmail = lazy(() =>
  import("../../../Entry/EntryComponents/confirm_email")
);

const VyrillUiElementRoutes = [
  {},
  {
    // element: <SuiteHome />,
    element: <Dashboradv3 />,
    path: "/home",
    meta: {
      className: "ecommerce-application v3-dashboard-bg",
    },
  },
  {
    element: <VideoDetailContainer />,
    path: "/home/videos/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    path: "/select-brand",
    element: <SelectBrand />,
    meta: {
      // layout: 'blank',
      menuHidden: true,
    },
  },
  {
    path: "/onboarding",
    element: <Onboarding />,
    meta: {
      layout: "blank",
      menuHidden: true,
    },
  },
  {
    path: "/firsttimeuser",
    element: <FirstTimeUser />,
    meta: {
      layout: "blank",
      menuHidden: true,
    },
  },
  // {
  //   element: <Search />,
  //   path: '/search'
  // },
  {
    element: <Product />,
    path: "/products",
    meta: {
      className: "ecommerce-application v2-page-bg",
    },
  },
  {
    element: <VideoDetailContainer />,
    path: "/products/videos/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    element: <ProductDetailContainer />,
    path: "/products/:id",
    meta: {
      className: "ecommerce-application v2-page-bg",
    },
  },
  {
    element: <Video />,
    path: "/videos",
    meta: {
      className: "video-application v2-page-bg",
    },
  },

  {
    element: <VideoDetailContainer />,
    path: "/videos/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    element: <Widget />,
    path: "/video_carousel",
    meta: {
      className: "video-application v2-page-bg",
    },
  },

  {
    element: <Published />,
    path: "/published",
    meta: {
      className: "video-application v2-page-bg",
    },
  },

  {
    element: <VideoDetailContainer />,
    path: "/published/videos/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    element: <AccountSettings />,
    path: "/account-settings",
    meta: {
      className: "account-settings",
    },
  },
  {
    element: <Support />,
    path: "/support",
    meta: {
      className: "account-settings v2-page-bg",
    },
  },
  // {  hiding creator tab
  //   element: <Influencer />,
  //   path: "/influencers",
  //   meta: {
  //     className: "ecommerce-application v2-page-bg",
  //   },
  // },
  {
    element: <VideoDetailContainer />,
    path: "/influencers/videos/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    element: <InfluencerDetailContainer />,
    path: "/influencers/:id",
    meta: {
      className: "ecommerce-application v2-page-bg",
    },
  },
  {
    element: <Reports />,
    path: "/report",
    meta: {
      className: "ecommerce-application v2-page-bg",
    },
  },
  {
    element: <VideoDetailContainer />,
    path: "/report/videos/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    element: <VideoDetailContainer />,
    path: "/published/:id",
    meta: {
      className: "video-details v2-page-bg",
    },
  },
  {
    element: <Campaign />,
    path: "/campaign",
    meta: {
      className: "campaign-application",
    },
  },
  {
    element: <CampaignListPage />,
    path: "/videos/campaigns",
    meta: {
      className: "campaign-application v2-page-bg",
    },
  },

  {
    element: <CampaignDetailPage />,
    path: "/videos/campaigns/:campaignId",
    meta: {
      className: "campaign-application v2-page-bg",
    },
  },
  // {
  //   element: <ChatIndex />,
  //   path: "/chat",
  // },
  // {
  //   element: <ChatDetail />,
  //   path: "/chat/:id",
  // },
  {
    element: <SuiteHome />,
    path: "/Campaigns",
  },
  {
    element: <SuiteHome />,
    path: "/videoApp",
  },
  {
    // element: <SuiteHome />,
    element: <AskVyrillChat />,
    path: "/ask_vyrill",
    meta: {
      className: "ecommerce-application v2-page-bg",
    },
  },

  {
    // element: <SuiteHome />,
    element: <CreateCampaign />,
    path: "/create_campaign",
    meta: {
      className: "ecommerce-application v2-page-bg",
    },
  },
];

export default VyrillUiElementRoutes;
